import React from 'react'
import './SuccessMessage.scss'

function SuccessMessage (props) {
  if (!props.text) { return null }
  return <div className="success-message">{props.text}</div>
}

export default SuccessMessage
